// Componente de skeleton para la página de inicio - Skeleton component for the home page
// Muestra placeholders que respetan la estructura de los bloques del dashboard
import { SectionBox } from '@shared/components/ui/SectionBox';
import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

export const HomeSkeleton = () => {
  return (
    <div className="min-h-screen bg-body-bg">
      {/* Layout principal en dos columnas - Main layout in two columns */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Columna izquierda - Left column */}
        <div className="space-y-6">
          {/* OrdersPreparedToday Skeleton - Skeleton de pedidos preparados hoy */}
          <SectionBox className="bg-card-bg">
            <Skeleton className="h-5 w-40 rounded-full mb-3 bg-hover-press" />
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-16 rounded-full bg-hover-press" />
              </div>
              {/* Barra de progreso - Progress bar */}
              <div className="w-full bg-card-border rounded-full h-2">
                <Skeleton className="h-2 w-3/4 rounded-full bg-hover-press" />
              </div>
            </div>
          </SectionBox>

          {/* OrderStatusMetrics Skeleton - Skeleton de métricas de estado de pedidos */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 !mt-4">
            {[1, 2, 3, 4].map((index) => (
              <SectionBox key={index} className="bg-card-bg">
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <Skeleton className="h-4 w-24 rounded-full mb-1 bg-hover-press" />
                    <Skeleton className="h-8 w-16 rounded-full bg-hover-press" />
                  </div>
                  <Skeleton className="h-8 w-8 rounded-md bg-hover-press" />
                </div>
              </SectionBox>
            ))}
          </div>
        </div>

        {/* Columna derecha - Right column */}
        <div className="space-y-6">
          {/* OrdersWithErrors Skeleton - Skeleton de pedidos con errores */}
          <SectionBox className="bg-card-bg flex flex-col">
            <div className="h-full flex flex-col">
              <div className="flex items-center gap-2 mb-4">
                <Skeleton className="h-8 w-8 rounded-md bg-hover-press" />
                <Skeleton className="h-5 w-40 rounded-full bg-hover-press" />
                <Skeleton className="h-5 w-16 rounded-full ml-auto bg-hover-press" />
              </div>
              {/* Gráfico donut - Donut chart */}
              <div className="flex-1 flex items-center justify-center">
                <Skeleton className="h-48 w-48 rounded-full bg-hover-press" />
              </div>
              {/* Leyenda - Legend */}
              <div className="mt-4 space-y-2">
                {[1, 2, 3, 4, 5].map((index) => (
                  <div key={index} className="flex items-center gap-2">
                    <Skeleton className="h-3 w-3 rounded-full bg-hover-press" />
                    <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                    <Skeleton className="h-4 w-12 rounded-full ml-auto bg-hover-press" />
                  </div>
                ))}
              </div>
            </div>
          </SectionBox>
        </div>

        {/* Columna izquierda - Left column (segunda fila) */}
        <div className="space-y-6">
          {/* ShippedProducts Skeleton - Skeleton de productos enviados */}
          <SectionBox className="bg-card-bg">
            <div className="flex items-center gap-2 mb-4">
              <Skeleton className="h-8 w-8 rounded-md bg-hover-press" />
              <Skeleton className="h-5 w-36 rounded-full bg-hover-press" />
              <Skeleton className="h-5 w-20 rounded-full ml-auto bg-hover-press" />
            </div>
            <div className="space-y-4">
              {/* Lista de productos - Product list */}
              {[1, 2, 3].map((index) => (
                <div key={index} className="flex items-center justify-between py-3 border-b border-card-border">
                  <div className="flex items-center gap-3">
                    <Skeleton className="h-12 w-12 rounded-md bg-hover-press" />
                    <div className="space-y-2">
                      <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                      <Skeleton className="h-3 w-24 rounded-full bg-hover-press" />
                    </div>
                  </div>
                  <Skeleton className="h-6 w-12 rounded-full bg-hover-press" />
                </div>
              ))}
            </div>
          </SectionBox>
        </div>

        {/* Columna derecha - Right column (segunda fila) */}
        <div className="space-y-6">
          {/* InventoryMetrics Skeleton - Skeleton de entradas de mercancía */}
          <SectionBox className="bg-card-bg">
            <div className="flex items-center gap-2 mb-4">
              <Skeleton className="h-8 w-8 rounded-md bg-hover-press" />
              <Skeleton className="h-5 w-40 rounded-full bg-hover-press" />
              <Skeleton className="h-5 w-20 rounded-full ml-auto bg-hover-press" />
            </div>
            <div className="space-y-4">
              {/* Lista de mercancía - Merchandise list */}
              {[1, 2, 3].map((index) => (
                <div key={index} className="flex items-center justify-between py-3 border-b border-card-border">
                  <div className="flex items-center gap-3">
                    <Skeleton className="h-12 w-12 rounded-md bg-hover-press" />
                    <div className="space-y-2">
                      <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                      <Skeleton className="h-3 w-24 rounded-full bg-hover-press" />
                    </div>
                  </div>
                  <Skeleton className="h-6 w-12 rounded-full bg-hover-press" />
                </div>
              ))}
            </div>
          </SectionBox>
        </div>
      </div>

      {/* ChildTeamOrdersReport Skeleton - Skeleton del reporte de pedidos por cliente hijo */}
      <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SectionBox className="bg-card-bg">
          <div className="flex items-center justify-between mb-4">
            <Skeleton className="h-6 w-48 bg-hover-press" />
            <Skeleton className="h-10 w-64 bg-hover-press" />
          </div>
          {/* Tabla - Table */}
          <div className="space-y-3">
            {/* Encabezados - Headers */}
            <div className="flex items-center justify-between pb-2 border-b border-card-border">
              <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
              <Skeleton className="h-4 w-24 bg-hover-press" />
              <Skeleton className="h-4 w-20 bg-hover-press" />
            </div>
            {/* Filas - Rows */}
            {[1, 2, 3, 4].map((index) => (
              <div key={index} className="flex items-center justify-between py-2 border-b border-card-border">
                <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-24 bg-hover-press" />
                <Skeleton className="h-4 w-20 bg-hover-press" />
              </div>
            ))}
          </div>
        </SectionBox>
      </div>
    </div>
  );
};
